<app-main-layout>
  <router-outlet></router-outlet>
</app-main-layout>
<app-toast-container></app-toast-container>
